import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { catchError, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const apimToken = environment.apiToken;
  const authService = inject(MsalService);
  const activeAccount = authService.instance.getActiveAccount() || undefined;

  const accessTokenRequest = {
    scopes: [],
    account: activeAccount,
  };

  // Skip assets and i18n translation
  if (req.url.includes('/assets/')) {
    return next(req);
  }

  return authService.acquireTokenSilent(accessTokenRequest).pipe(
    catchError(() => authService.acquireTokenRedirect(accessTokenRequest)),
    switchMap((accessTokenResponse) => {
      const token = accessTokenResponse?.accessToken ?? '';
      const authReq = req.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json',
          'ocp-apim-subscription-key': apimToken,
          Token: `${token}`,
        },
      });
      return next(authReq);
    }),
  );
};
